import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import NoContentFound from '../../../default/not-found/notFound';
import { ShimmerCategoryItem } from 'react-shimmer-effects';
import SearchForm from '../../../default/search/searchForm';
import { useDispatch, useSelector } from 'react-redux';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { handleAddItem, handleCategoryDelete, handleRemoveCategoryItem, renameCategoryAction } from '../../../../store/actions/new/categoryActions';
import { CARD_CATEGORY_UPDATE } from '../../../../store/actions/types';
import ItemsSelectorPopup from '../../../default/popup/itemsSelectorPopup';
import RenamePopup from '../../../category/view/popup/renameCategory';
import { CONNECTION_CATEGORY_UPDATE } from '../../../../store/constants/connectionConstants';
import ShimmerImage from '../../../default/popup/shimmerImage/shimmerImage';
import { InitialAvatar } from '../../../default/utils/defaultAvatar';

const SingleConnectionCategoryList = () => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const navigate = useNavigate();
    const [catTitle, setCatTitle] = useState('');
    const [categoryId, setCategoryId] = useState('');
    const [renameModal, renameModalSet] = useState('');
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [loading, setLoading] = useState(null);
    const { id } = useParams();
    const prevSearchTermRef = useRef();
    const [pageCount, setPageCount] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [categoryTitle, setCategoryTitle] = useState('');
    const [hasLoaded, setHasLoaded] = useState(false);
    const [categoryData, setCategory] = useState({
        data: [],
        pagination: {
            data_total: 0
        }
    });

    const toggleDropdown = (index) => {
        setOpenDropdown(prevIndex => (prevIndex === index ? null : index));
    };
    //out side click for dropdown
    const handleOutsideClick = (event) => {
        if (!event.target.closest('.list-edit-dropdown') &&
            !event.target.closest('.dropdown-toggle-btn')) {
            setOpenDropdown(null);
        }
    };

    //function to show popup
    const [openCategoryItemModal, setCategoryItemModal] = useState(false);
    const handlePopup = () => {
        setCategoryItemModal(true);
    }
    // add new item to the group
    const dispatch = useDispatch();
    const handleItemSelect = async (item) => {
        setCategoryItemModal(false);
        setIsLoading(true)
        let response = await dispatch(handleAddItem(id, item, "card_connects"));

        // send request by action to get card info
        if (response) {
            let connectionData = await axios.get(`card/connects/list?id=${item.id}&groupID=${id}`);
            setCategory(prev => ({
                data: [...(Array.isArray(prev.data) ? prev.data : []), connectionData.data.data[0]],
                pagination: {
                    ...prev.pagination,
                    data_total: prev.pagination.data_total + 1
                }
            }));
            setIsLoading(false)

        } else {
            setIsLoading(false)
        }
    };
    //fetch category data
    const fetchCardCategoryData = async (postData) => {
        setIsLoading(true);
        try {
            const response = await axios.get(`card/connects/list?groupID=${id}`, { params: postData });
            const { data, pagination } = response.data;
            if (postData.page > 1) {
                setCategory(prev => ({
                    data: [...prev.data, ...data],
                    pagination
                }));
            } else {
                setCategory({ data, pagination });
            }
            setIsLoading(false);
        } catch (err) {
            setError(err.message);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (!hasLoaded) {
            let postData = {
                page: 1,
                keyword: ''
            }
            fetchCardCategoryData(postData);
            setHasLoaded(true);
        }
        if (prevSearchTermRef.current !== searchTerm) {
            searchCategoryData();
        }
        prevSearchTermRef.current = searchTerm;

    }, [searchTerm]);

    //search category data
    const searchCategoryData = async () => {
        if (!hasLoaded) return;
        setLoading(true);
        let postData = {
            page: 1,
            keyword: searchTerm
        }
        await fetchCardCategoryData(postData);
        setLoading(false);
    }

    // category pagination
    const loadMore = () => {
        const nextPage = categoryData.pagination.page + 1;
        if (nextPage <= categoryData.pagination.page_last) {
            setPageCount(nextPage);
            let postData = {
                page: nextPage,
                keyword: searchTerm
            }
            fetchCardCategoryData(postData);
        }

    };
    // get category Title by id
    const categoryState = useSelector((state) => state.connectionAllData);
    const connectionData = categoryState;
    const { category } = connectionData;
    useEffect(() => {
        if (Array.isArray(category.data) && category.data.length > 0) {
            const matchedItem = category.data.find(item => item.id === id);
            if (matchedItem) {
                setCategoryTitle(matchedItem.title);
            } else {
                getCatTitle();
            }
        } else {
            getCatTitle();
        }
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [category, id]);

    //Get category title
    const getCatTitle = async () => {
        try {
            const catTitle = await axios.get(`essential/group?id=${id}`);
            console.log(catTitle.data)
            setCategoryTitle(catTitle.data.data[0].title);

        } catch (err) {
            setError(err.message);
        }
    }
    //Delete category item
    const MySwal = withReactContent(Swal)
    const handleDeleteItem = async (itemId, cardId) => {
        setOpenDropdown(false);
        const result = await MySwal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#ccc",
            confirmButtonText: "Conform",
            didOpen: () => {
                document.body.style.overflow = "hidden";
            },
            willClose: () => {
                document.body.style.overflow = "";
            }
        });
        if (result.isConfirmed) {
            const response = await dispatch(handleRemoveCategoryItem(itemId));
            if (response) {
                setCategory(prev => ({
                    data: prev.data.filter(item => item.ID !== cardId),
                    pagination: {
                        ...prev.pagination,
                        data_total: prev.pagination.data_total - 1
                    }
                }));
            }
        }

    };
    // Rename Category
    const handleRenameModal = (id, title) => {
        setCategoryId(id)
        setCatTitle(title)
        renameModalSet(true);
        setOpenDropdown(null)
    };
    const handleUpdateCategory = async (newCategoryName) => {
        setCatTitle(newCategoryName);

        try {
            const response = await dispatch(renameCategoryAction(categoryId, newCategoryName));
            if (response.status >= 200) {
                dispatch({
                    type: CONNECTION_CATEGORY_UPDATE,
                    payload: {
                        catId: categoryId,
                        title: newCategoryName,
                        data: response.data
                    }
                });
                return true;
            }
        } catch (error) {
            console.error('Failed to update category:', error);
        }
    }
    // Delete category
    const handleDeleteCategory = (catId, type) => {
        setOpenDropdown(null)
        MySwal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#ccc",
            confirmButtonText: "Conform",
            didOpen: () => {
                document.body.style.overflow = "hidden";
            },
            willClose: () => {
                document.body.style.overflow = "";
            }
        }).then(async (result) => {
            if (result.isConfirmed) {
                let response = await dispatch(handleCategoryDelete(catId, type));
                if (response.status >= 200) {
                    navigate(-1);
                }
            }
        });

    }

    return (
        <div className="card-container card-list-area">
            <div className="connection-header">
                <h3>{categoryTitle}</h3>
                <div className="filter-wrapper">
                    <SearchForm
                        placeholder='Search card...'
                        loading={loading}
                        onChange={async (val) => {
                            setSearchTerm(val);
                        }}

                    />
                    <div onClick={handlePopup} className="list-filter add-new-btn">
                        <i className="ri-add-line"></i>
                        <span>Add New</span>
                    </div>
                    <div className="category-dropdown">
                        <div className="list-edit-dropdown">
                            <i
                                className="ri-more-2-fill"
                                onClick={() => toggleDropdown(999999)}
                            ></i>
                            {openDropdown === 999999 && (
                                <ul>
                                    <li><Link onClick={() => handleRenameModal(id, categoryTitle)}>Rename Category</Link></li>
                                    <li><Link onClick={() => handleDeleteCategory(id, "single_cards")}>Delete Category</Link></li>
                                </ul>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="list-table connection-list">
                {categoryData.data && categoryData.data.length > 0 && (
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Job title</th>
                                <th>Company</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {categoryData.data && categoryData.data.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <div className="list-profile">
                                            {item.card_photo ? (
                                                <ShimmerImage
                                                    src={item.card_photo}
                                                    alt={item.card_name}
                                                    width={65}
                                                />
                                            ) : (
                                                <InitialAvatar
                                                    title={`${item.card_name}`}
                                                    size={65}
                                                />
                                            )}
                                            <span>{item.card_name}</span>
                                        </div>
                                    </td>
                                    <td>{item.card_title}</td>
                                    <td>{item.card_company}</td>
                                    <td align='right'>
                                        <Link className="card-btn list-btn" to={item.card_link} target='gms'>
                                            <i className="ri-eye-line"></i> View
                                        </Link>
                                        <button
                                            className="share-button icon-button list-btn dropdown-toggle-btn"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                toggleDropdown(index);
                                            }}
                                        >
                                            <i
                                                className="ri-more-2-fill"
                                            ></i>
                                        </button>
                                        <div className="list-edit-dropdown">
                                            {openDropdown === index && (
                                                <ul>
                                                    <li><Link onClick={() => handleDeleteItem(item.groupItemID, item.ID)}>Remove</Link></li>
                                                </ul>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
                {!isLoading && categoryData !== null && categoryData.pagination.data_total === 0 &&
                    <NoContentFound title="No data found!" />
                }
                {isLoading &&
                    <>
                        <ShimmerCategoryItem
                            hasImage
                            imageType="circular"
                            imageWidth={50}
                            imageHeight={50}
                            text
                        />
                        <ShimmerCategoryItem
                            hasImage
                            imageType="circular"
                            imageWidth={50}
                            imageHeight={50}
                            text
                        />
                    </>
                }
                {!isLoading && categoryData !== null && categoryData.pagination.page_last > categoryData.pagination.page && (
                    <div className="load-more-container">
                        <button
                            className="load-more-btn"
                            onClick={loadMore}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Loading...' : 'Load More'}
                        </button>
                    </div>
                )}

            </div>
            {/* popup */}
            <ItemsSelectorPopup openModal={openCategoryItemModal} setOpen={setCategoryItemModal} onItemSelect={handleItemSelect} type="card_connects" title="Select Item" />
            <RenamePopup openModal={renameModal} setOpen={renameModalSet} title={catTitle} onCategoryUpdate={handleUpdateCategory} />
        </div>
    );
}

export default SingleConnectionCategoryList;
